import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaRedo } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';

function ResendCallNotificationButton({ handler, label, tooltip = '' }: {
  handler: () => void,
  label: string,
  tooltip?: string,
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={(
        <Tooltip id="resend-call-notification-button-tooltip">
          {tooltip || t('Resend_Call_Notification')}
        </Tooltip>
      )}
    >
      <Button variant="link" className="linkactions" onClick={handler}>
        <FaRedo />
        {label && (<span>{label}</span>)}
      </Button>
    </OverlayTrigger>
  );
}

ResendCallNotificationButton.defaultProps = {
  tooltip: '',
};

export default ResendCallNotificationButton;
